import { render, staticRenderFns } from "./InstagramDmTestIssueForm.vue?vue&type=template&id=287935f2&scoped=true"
import script from "./InstagramDmTestIssueForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./InstagramDmTestIssueForm.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./InstagramDmTestIssueForm.vue?vue&type=style&index=0&id=287935f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287935f2",
  null
  
)

export default component.exports